var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-12 box"},[_c('div',{staticClass:"box__header"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.btnBack)?_c('btn-back',{attrs:{"route":_vm.routeBtnBack}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"box__inputs"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b6e9a37","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/components/layouts/boxListFilter.vue
// module id = 1267
// module chunks = 0